import type {DalValue, ComponentWithResolvedDataItems, SchemaService, VariantSplit} from '@wix/document-services-types'
import {VARIANTS_DATA_TYPES, DATA_TYPES} from '@wix/format-converter-schemas'
import _ from 'lodash'
import {REF_ARRAY_DATA_TYPE} from '../../constants'
import type {SingleComponentPluginFunction} from '../../types'
import {
    type ReferredDataItemsIterateeContext,
    createVariantRelation,
    forEachReferredDataItem
} from '@wix/import-export-utils'

const PREFERRED_SINGLE_ITEM_NAMESPACES = new Set([DATA_TYPES.design])

export const convertVariantSplitToDataItem = (
    {default: defaultValue, variants}: VariantSplit,
    namespace: string,
    componentId: string
): DalValue => {
    if (!variants || (variants.length === 0 && PREFERRED_SINGLE_ITEM_NAMESPACES.has(namespace))) {
        return defaultValue
    }

    const refArray = {
        type: REF_ARRAY_DATA_TYPE,
        values: variants.map(variant => createVariantRelation(variant.conditions, componentId, variant.value))
    }

    if (defaultValue) {
        refArray.values.unshift(defaultValue)
    }

    return refArray
}

export const unpack: SingleComponentPluginFunction = (
    component: ComponentWithResolvedDataItems,
    schemaService: SchemaService
): void => {
    _.forOwn(VARIANTS_DATA_TYPES, (namespace: string) => {
        const {structure: componentStructure, data: componentData} = component
        const featureData = componentData[namespace]
        if (!featureData) {
            return
        }

        forEachReferredDataItem(
            schemaService,
            featureData,
            namespace,
            ({
                item,
                namespace: itemNamespace,
                itemRefInfo,
                ownerItem = componentData
            }: ReferredDataItemsIterateeContext) => {
                if (itemRefInfo.isRelationalSplit) {
                    _.set(
                        ownerItem,
                        itemRefInfo.path,
                        convertVariantSplitToDataItem(item, itemNamespace, componentStructure.id)
                    )
                }
            }
        )
    })
}
